export const HIDDEN_ROLES: ReadonlyArray<string> = ['super-admin', 'data-entry', 'system']
